import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authReducer";
import adminReducer from "./adminReducer";
import driverReducer from "./driverReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "admin", "driver"],
};

const reducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  driver: driverReducer,
});

export default persistReducer(persistConfig, reducer);
